import { render, staticRenderFns } from "./EventRequirements.vue?vue&type=template&id=1d98a7de"
import script from "./EventRequirements.vue?vue&type=script&lang=js"
export * from "./EventRequirements.vue?vue&type=script&lang=js"
import style0 from "./EventRequirements.vue?vue&type=style&index=0&id=1d98a7de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports